var map = {
	"./en/aboutUs": [
		"6L8o",
		20
	],
	"./en/aboutUs.json": [
		"6L8o",
		20
	],
	"./en/contactUs": [
		"6NUQ",
		21
	],
	"./en/contactUs.json": [
		"6NUQ",
		21
	],
	"./en/game": [
		"ZubD",
		22
	],
	"./en/game.json": [
		"ZubD",
		22
	],
	"./en/gameLearn": [
		"mWeZ",
		23
	],
	"./en/gameLearn.json": [
		"mWeZ",
		23
	],
	"./en/home": [
		"PqKL",
		24
	],
	"./en/home.json": [
		"PqKL",
		24
	],
	"./en/learnFlashcards": [
		"99Xu",
		25
	],
	"./en/learnFlashcards.json": [
		"99Xu",
		25
	],
	"./en/loginWithKanoon": [
		"hPoB",
		26
	],
	"./en/loginWithKanoon.json": [
		"hPoB",
		26
	],
	"./en/navbar": [
		"wqyF",
		27
	],
	"./en/navbar.json": [
		"wqyF",
		27
	],
	"./en/profile": [
		"PIbS",
		28
	],
	"./en/profile.json": [
		"PIbS",
		28
	],
	"./en/readStories": [
		"G3R7",
		29
	],
	"./en/readStories.json": [
		"G3R7",
		29
	],
	"./en/register": [
		"l/yl",
		30
	],
	"./en/register.json": [
		"l/yl",
		30
	],
	"./en/result": [
		"+rZK",
		31
	],
	"./en/result.json": [
		"+rZK",
		31
	],
	"./en/score": [
		"Ytq9",
		32
	],
	"./en/score.json": [
		"Ytq9",
		32
	],
	"./en/start": [
		"UVZW",
		33
	],
	"./en/start.json": [
		"UVZW",
		33
	],
	"./en/story": [
		"So9m",
		34
	],
	"./en/story.json": [
		"So9m",
		34
	],
	"./en/topUsers": [
		"WQt5",
		35
	],
	"./en/topUsers.json": [
		"WQt5",
		35
	],
	"./en/verifyCode": [
		"sVuS",
		36
	],
	"./en/verifyCode.json": [
		"sVuS",
		36
	],
	"./en/verifyPhone": [
		"HufV",
		37
	],
	"./en/verifyPhone.json": [
		"HufV",
		37
	],
	"./farsi/aboutUs": [
		"g1NT",
		38
	],
	"./farsi/aboutUs.json": [
		"g1NT",
		38
	],
	"./farsi/contactUs": [
		"mHKl",
		39
	],
	"./farsi/contactUs.json": [
		"mHKl",
		39
	],
	"./farsi/game": [
		"PRev",
		40
	],
	"./farsi/game.json": [
		"PRev",
		40
	],
	"./farsi/gameLearn": [
		"N+En",
		41
	],
	"./farsi/gameLearn.json": [
		"N+En",
		41
	],
	"./farsi/home": [
		"q+Ou",
		42
	],
	"./farsi/home.json": [
		"q+Ou",
		42
	],
	"./farsi/learnFlashcards": [
		"93hF",
		43
	],
	"./farsi/learnFlashcards.json": [
		"93hF",
		43
	],
	"./farsi/loginWithKanoon": [
		"M/Ww",
		44
	],
	"./farsi/loginWithKanoon.json": [
		"M/Ww",
		44
	],
	"./farsi/navbar": [
		"s2nO",
		45
	],
	"./farsi/navbar.json": [
		"s2nO",
		45
	],
	"./farsi/profile": [
		"/jzS",
		46
	],
	"./farsi/profile.json": [
		"/jzS",
		46
	],
	"./farsi/readStories": [
		"MmkR",
		47
	],
	"./farsi/readStories.json": [
		"MmkR",
		47
	],
	"./farsi/register": [
		"I/V5",
		48
	],
	"./farsi/register.json": [
		"I/V5",
		48
	],
	"./farsi/result": [
		"w9n0",
		49
	],
	"./farsi/result.json": [
		"w9n0",
		49
	],
	"./farsi/score": [
		"x7Wo",
		50
	],
	"./farsi/score.json": [
		"x7Wo",
		50
	],
	"./farsi/start": [
		"hWW0",
		51
	],
	"./farsi/start.json": [
		"hWW0",
		51
	],
	"./farsi/story": [
		"Q6Xt",
		52
	],
	"./farsi/story.json": [
		"Q6Xt",
		52
	],
	"./farsi/topUsers": [
		"cQ/y",
		53
	],
	"./farsi/topUsers.json": [
		"cQ/y",
		53
	],
	"./farsi/verifyCode": [
		"stmp",
		54
	],
	"./farsi/verifyCode.json": [
		"stmp",
		54
	],
	"./farsi/verifyPhone": [
		"2ZA6",
		55
	],
	"./farsi/verifyPhone.json": [
		"2ZA6",
		55
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5bgu";
module.exports = webpackAsyncContext;